import moment from "moment"
import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import Post from "../api/Post"
import { DOCTOR_DINAMIC_SCHEDULE } from "../api/Routes"
import SimpleLoad from "../loader/SimpleLoad"
import { getTokenExternal } from "../utils/getTokenExternal"
import ComponentModalErrorSever from "./ComponentModalErrorSever"
import CardHorariosDoctor from "./doctor/CardHorariosDoctor"
import ListaVacia from "./ListaVacia"

function ItemsHourExternal({t, doctorId, onClickSelectedSchedule, account, company, currentPage, linkAllianz, isSort, setIsSort, ordering, setCheckIndex, 
    setBasicItems,basicItems, doctorRef,setCountDr, countDr}){
    const [fecha, setFecha] = useState(new Date())
    const [loading,setLoading] = useState(true)
    const [horario, setHorario] = useState(null)
    const [indexSelectHor, setIndexSelectHor] = useState(null)
    const [itemHor, setItemHor] = useState(null)
    const [startDay, setStartDay] = useState(0)
    const comp = company ? company : account.partner.company
    const days = comp.id === 2 ? 3 : 7
    const location = useLocation()
    //console.log(linkAllianz)
    const link = linkAllianz ? linkAllianz : account.id === 57 ? true : false
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [allHorarios, setAllHorarios] = useState([])
    const [aDays, setADays] = useState(7)


    useEffect(()=>{
        if(isSort){
            setFecha(new Date())
        }
    }, [isSort])

    //console.log(moment(fecha).add(7, 'days').format("DD-MM-YYYY"))
    //console.log(allHorarios)
    useEffect(() => {        
        //get token para seguridad
        let mounted = true
        setLoading(true)
        getTokenExternal(company ? company : account.partner.company)
        .then(response=>{
            if(mounted){
                let correctLink = link
                if(location.pathname.includes('autoagendamiento')) correctLink = false;
                let url = `${DOCTOR_DINAMIC_SCHEDULE}?doctorId=${doctorId}&dateIni=${moment(fecha).format("DD-MM-YYYY")}&dateEnd=${moment(fecha).add(7, 'days').format("DD-MM-YYYY")}&accountId=${account.id}&link=${correctLink}`
                Post({url: url, data: {}, access_token: response.data.access_token, header: true})
                .then(res=>{
                    
                    //console.log(res.data.data.response)               
                    //setHorario(obj)
                    

                    const allkeys = Object.keys(res.data.data.response).sort((a,b) => moment(a).toDate().getTime() - moment(b).toDate().getTime());
                    const arrH = []
                    allkeys.forEach(ele => {
                        //console.log(ele)
                        let objH = {
                            key: ele,
                            value:  res.data.data.response[ele]
                        }
                        //console.log(objH)
                        if(objH.value.length > 0){
                            arrH.push(objH)
                            
                        }
                    })
                    setADays(arrH.length)
                    setAllHorarios(arrH)
                    if(arrH.length > 0){
                        //console.log(arrH)
                        setHorario(arrH[0])
                        if(basicItems){
                            //console.log(basicItems)
                            let findIndex = basicItems.findIndex((el)=>el.doctor.id===doctorId)
                            basicItems[findIndex].values = arrH[0].value
                            setBasicItems(basicItems)
                            //setIsSort(false)
                        }
                    }else{
                        if(basicItems){
                            let findIndex = basicItems.findIndex((el)=>el.doctor.id===doctorId)
                            basicItems[findIndex].values = []
                            setBasicItems(basicItems)
                            //setIsSort(false)
                        }
                    }

                    setLoading(false)
                    setCountDr(prev=>prev-1)
                })
                .catch(err=>{
                    setLoading(false)
                    setShowModalError(true)
                    if(err.response){
                        setErrorServer(err.response)
                    }
                })
            }
        })
        .catch(error=>{
            setLoading(false)
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        return () => mounted = false;
    }, [isSort])
    //fecha, currentPage, isSort, doctorRef

    const selectTime = index =>{
        setItemHor(horario.value[index])
        setIndexSelectHor(index)  
        onClickSelectedSchedule(horario.value[index], doctorId)      
    }
    
    const plusDay2 = n => {
        let nDays = startDay+n
        setStartDay(nDays)
        setHorario(allHorarios[nDays])
    }
    const minusDay2 = n => {
        let nDays = startDay-n
        setStartDay(nDays)
        setHorario(allHorarios[nDays])
    }

    return (
        <>
            {(loading || countDr > 0) && <SimpleLoad />}
            {horario ? <CardHorariosDoctor 
                horario={horario} 
                selectTime={selectTime}
                indexSelect={indexSelectHor}
                days={aDays}
                plusDay={plusDay2}
                minusDay={minusDay2}
                startDay={startDay}
            /> : <ListaVacia texto={t('no_hay_disponiblidad')} />}
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
        
    )
}

export default withTranslation()(ItemsHourExternal)